<script lang="ts">
	import Link from '$lib/components/atoms/link/Link.svelte';

	interface Props {
		image: string;
		textViewMoreOn: string;
		textViewMoreOnPartnerWebsite: string;
		textViewMoreGoToPartnerWebsite: string;
		altText: string;
		bookUrl: string;
		onHandleClick?: () => void;
	}

	const {
		image,
		textViewMoreOn,
		textViewMoreOnPartnerWebsite,
		textViewMoreGoToPartnerWebsite,
		altText,
		bookUrl,
		onHandleClick,
	}: Props = $props();

</script>

<img class="w-22 h-22" src={image} alt={altText} />
<div class="text-sm text-neutral-strongest text-center">
	<div class="text-sm text-neutral-strongest text-center">
		{textViewMoreOn}
	</div>
	<div class="text-bold decoration-underline">
		{textViewMoreOnPartnerWebsite}
	</div>
</div>
<Link
	button="filled"
	href={bookUrl}
	target={bookUrl ? '_self' : '_blank'}
	rel="external"
	label={textViewMoreGoToPartnerWebsite}
	icon="open-in-new"
	iconPosition="right"
	onclick={(event) => {
		event.stopPropagation();
		onHandleClick?.();
	}}
/>
